<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="工程名称">
              <a-input placeholder="请输入工程名称" v-model="queryParam.infoName"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="项目经理">
              <a-input placeholder="请输入项目经理" v-model="queryParam.projectContractManager"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="建立日期">
              <a-date-picker @change="onChange" v-model="clearDate"></a-date-picker>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
            <a-button @click="() => {queryParam = {},clearDate = undefined}" style="margin-left: 8px">重置</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      bordered
      ref="table"
      :data="loadData"
      :columns="columns"
      :rowKey="record => record.id"
    >
    </s-table>
  </a-card>
</template>

<script>
import moment from 'moment'
import { TableMixin } from '@/mixins/TableMixin'
import { fetchList, delObj } from '@/api/project/ProjectBuildInfo'
import projectBuildInfoAddOrUpdate from './buildInfoAddOrUpdate'
import { enterEvent } from '@/utils/util'
import { Ellipsis } from '@/components'
export default {
  name: 'ProjectBuildInfoView',
  mixins: [TableMixin],
  components: {
    projectBuildInfoAddOrUpdate,
    Ellipsis
  },
  data () {
    return {
      description: '对公司的施工工程信息进行留档管理',
      clearDate: undefined,
      queryParam: {
        infoName: '',
        projectContractManager: '',
        projectBuildDate: undefined
      },
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      },
      columns: [
        {
          title: '序号',
          width: '62px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        {
          title: '工程名称',
          dataIndex: 'infoName',
          customRender: (text) => {
            return (
              <ellipsis length={50} tooltip>{text}</ellipsis>
            )
          }
        },
        {
          title: '合同额(元)',
          width: '120px',
          dataIndex: 'biddingContractAmount',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' - ' : Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '项目经理',
          width: '120px',
          dataIndex: 'projectContractManager'
        },
        {
          title: '项目建立日期',
          width: '150px',
          dataIndex: 'projectBuildDate'
        },
        {
          title: '操作',
          width: '200px',
          customRender: (record) => {
            return (
              <div>
                <span v-action="build:projectBuildInfo:add">
                  <a onClick={(e) => this.edit(record)}
                    type="primary"
                    icon="edit"
                  >信息添加</a>
                  <a-divider type="vertical" />
                </span>
                <span v-action="build:projectBuildInfo:show">
                  <a onClick={(e) => this.show(record)}
                    type="primary"
                    icon="edit"
                  >详情</a>
                </span>
                <span v-action="build:projectBuildInfo:del">
                  <a-divider type="vertical" />
                  <a-popconfirm title="是否删除" onConfirm={() => this.deleteItem(record)} okText="是" cancelText="否">
                    <a-icon slot="icon" type="question-circle-o" style="color: red" />
                    <a href="javascript:;" style="color: red">删除</a>
                  </a-popconfirm>
                </span>
              </div>
            )
          }
        }
      ]
    }
  },
  methods: {
    show (record) {
      this.$router.push({ name: 'ProjectBuildInfoUpdate', query: { buildId: record.id, type: 'show' } })
    },
    edit (record) {
      this.$router.push({ name: 'ProjectBuildInfoUpdate', query: { buildId: record.id, type: 'edit' } })
    },
    deleteItem (record) {
      delObj(record.id).then(res => {
        this.$message.info('删除成功')
        this.queryPage()
      })
    },
    onChange (date, dateString) {
      // 格式化日期类
      if (date !== null) {
        // this.queryParam.dailyDate = date.format('YYYY-MM-DD HH:mm:ss')
        this.queryParam.projectBuildDate = moment(date).format('YYYY-MM-DD')
      } else {
        this.queryParam.projectBuildDate = undefined
      }
    }
  },
  created () {
    enterEvent(this.queryPage)
  },
  activated () {
    this.queryPage()
  }
}
</script>

<style scoped>

</style>
